import React, { useState } from "react";
import { backend_domain } from "../helpers";
import { Link } from "react-router-dom";

const ProductCard = ({ product, cartUpdate, user }) => {
  const [currentQty, setCurrentQty] = useState(
    product?.sales_order_qty ? product?.sales_order_qty : 0
  );

  return (
    <div className="col-xxl-2 col-lg-3 col-sm-4 col-6 my-12">
      <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
        <a
          href={`/singleProduct?id=${product?.item_code}`}
          className="custom-product-card__thumb product-card__thumb flex-center rounded-8 bg-gray-50 position-relative mb-10"
        >
          <img src={`${backend_domain}${product?.images[0]}`} alt="" />
        </a>
        <div className="product-card__content custom-product-card__content p-sm-2 w-100">
          <h6 className="title text-lg fw-semibold mt-12 mb-8">
            <a
              className="link text-line-2"
              href={`/singleProduct?id=${product?.item_code}`}
            >
              {product?.item_name}
            </a>
          </h6>
          <div className="flex-align gap-4">
            <span className="text-main-600 text-md d-flex"></span>
            <span className="text-gray-500 text-xs"></span>
          </div>
          <div className="product-card__content mt-12">
            <div className="product-card__price mb-8">
              <span className="text-heading text-md fw-semibold ">
                {`${product?.price} KD`}
              </span>
              {/* <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                5.00KD
              </span> */}
            </div>

            {user?.name == "guest" ? (
              <Link
                to="/login"
                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
              >
                Add To Cart <i className="ph ph-shopping-cart" />
              </Link>
            ) : currentQty > 0 ? (
              <div className="d-flex rounded-4 overflow-hidden">
                <button
                  type="button"
                  onClick={() => {
                    setCurrentQty(currentQty - 1);

                    cartUpdate({
                      item_code: product?.item_code,
                      qty: currentQty - 1,
                      rate: product?.price,
                    });
                  }}
                  className="quantity__minus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                >
                  <i className="ph ph-minus" />
                </button>
                <input
                  type="number"
                  className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-16"
                  id="stock"
                  readOnly
                  value={currentQty}
                />
                <button
                  type="button"
                  onClick={() => {
                    setCurrentQty(currentQty + 1);

                    cartUpdate({
                      item_code: product?.item_code,
                      qty: currentQty + 1,
                      rate: product?.price,
                    });
                  }}
                  className="quantity__plus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                >
                  <i className="ph ph-plus" />
                </button>
              </div>
            ) : (
              <button
                onClick={() => {
                  cartUpdate({
                    item_code: product?.item_code,
                    qty: 1.0,
                    rate: product?.price,
                  });
                  setCurrentQty(1);
                }}
                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
              >
                Add To Cart <i className="ph ph-shopping-cart" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
